import styles from "./Descriptions.module.scss"

import type { TitleDescriptionsComponent } from "."

export const TitleDescriptions: TitleDescriptionsComponent = ({ children }) => (
  <span className={styles.title}>{children}</span>
)
